import { Injectable } from '@angular/core';
import { CloudFunctionsApiService } from '../../services/cloud-functions-api.service';

@Injectable({
  providedIn: 'root',
})
export class ChatService {
  constructor(private api: CloudFunctionsApiService) {}

  getChats() {
    return this.api.snapshotList('/chats');
  }

  getChatsNow() {
    return this.api.getCollection('/chats');
  }

  getMessages(chatid) {
    return this.api.snapshotList(`/chats/${chatid}/messages`);
  }

  getMessagesNow(chatid) {
    return this.api.getCollection(`/chats/${chatid}/messages`);
  }
}
